module.exports = __webpack_public_path__ + "static/media/video-icon.6e33c8d5.svg";